import { useState } from 'react';
import { LinkifiedText } from '@/components/LinkifiedText';

/** Past this, the Timer shows the start of a description and a way to read the rest; the ring stays the focus. */
const SHORT = { lines: 4, chars: 280 };

/** A task's description under the goal, so what the task is about is one glance away rather than in another app. */
export function TaskNotes({ notes }: { notes: string }) {
  const [open, setOpen] = useState(false);
  const text = notes.trim();
  if (!text) return null;
  const long = text.split('\n').length > SHORT.lines || text.length > SHORT.chars;
  return (
    <div className="grid gap-1 justify-items-start">
      <p className={`text-[12.5px] font-semibold text-ink-2 leading-[1.55] m-0 whitespace-pre-wrap break-words ${long && !open ? 'line-clamp-4' : ''}`}><LinkifiedText text={text} /></p>
      {long && <button type="button" onClick={() => setOpen((o) => !o)} className="bg-transparent border-0 p-0 text-[12px] font-bold text-ink cursor-pointer underline underline-offset-2">{open ? 'Show less' : 'Show more'}</button>}
    </div>
  );
}
